import axios from 'axios';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';
import { HttpRequest } from './request.utils';
import cmis from 'cmis';
import qs from 'qs';
import { convertApis, baseUrlApis } from "Api/index";
import { URL_CWS_API, URL_CMIS } from './constants';

export default class StorageAppApi extends HttpRequest {
    constructor () {
        super();
        this.cmss = null;
        this.storageAppAxios = null;
        this.baseURL = null;
        this.init();
    }

    init () {
        baseUrlApis.getBaseUrlBy(URL_CMIS).then(data => {
            this.baseURL = data;
            this.storageAppAxios = axios.create({
                baseURL: this.baseURL,
            });
            super.initialize(this.storageAppAxios, () => {
                this.interceptorsProxyFn(null, {
                    success: (res) => {
                        return res.data;
                    },
                    error: (error) => {
                        this.errorHandler(error);
                        return Promise.reject(error);
                    },
                });
            });
        })
    }

    // 获取CMIS实例
    getCMIS () {
        if (this.cmss) return Promise.resolve(this.cmss);
        const URL = this.baseURL + '/browser';
        const TOKEN = store.userStore.token; // '6346771636132d29ea8ba4b7';
        if (!TOKEN) return ;
        this.cmss = new cmis.CmisSession(URL);
        return this.cmss
            .setToken(TOKEN)
            .setCharset('UTF-8')
            .loadRepositories().then(() => {
                // 切换根仓库为fxcId
                const rootFolderUrl = this.cmss.defaultRepository.rootFolderUrl;
                const repositoryUrl = this.cmss.defaultRepository.repositoryUrl;
                this.cmss.defaultRepository.rootFolderUrl = rootFolderUrl.replace('default', 'fxcld');
                this.cmss.defaultRepository.repositoryUrl = repositoryUrl.replace('default', 'fxcld');
                return this.cmss;
            });
    }

    errorHandler (error) {
        let errorMsg;
        if (typeof error === 'string') {
            errorMsg = error;
        } else if (error.msg) {
            errorMsg = error.msg;
        } else if (error.__CANCEL__) {
            errorMsg = intl.formatMessage({ id: 'CancelRequest' });
        } else {
            errorMsg = intl.formatMessage({ id: 'NetworkError' });
        }
        store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
    }
    
    getUserPath () {
        return this.get({
            url: `/rest/storage/userPath`,
            config: {
                params: {
                    access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                    enterpriseId: store.userStore.roleInfo?.enterpriseId,
                    type: 7
                }
            },
        });
    }
    getStarredList (pageIndex=1, pageSize=10) {
        const offset = (pageIndex - 1) * pageSize;
        return this.get({
            url: `/rest/storage/starred`,
            config: {
                params: {
                    access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                    enterpriseId: store.userStore.roleInfo?.enterpriseId,
                    offset: offset,
                    limit: pageSize
                }
            },
        }).then(res => {
            const data = res.data.starred;
            (data || []).forEach(item => {
                item.name = item.docName;
            });
            return data;
        });
    }
    // 标心
    addStarred (docId, docName, isMe, docSize, reviewSessionID) {
        return this.post({
            url: `/rest/storage/starred`,
            data: qs.stringify({
                access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                enterpriseId: store.userStore.roleInfo?.enterpriseId,
                docId: docId,
                docName: docName,
                isMe: isMe,
                reviewSessionID: reviewSessionID,
                docSize: docSize,
                lastModifiedTime: Date.now()
            }),
        });
    }
    // 移除标心
    removeStarred (docId) {
        return this.delete({
            url: `/rest/storage/starred`,
            config: {
                params: {
                    access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                    enterpriseId: store.userStore.roleInfo?.enterpriseId,
                    docId: docId,
                }
            },
        });
    }
    // 获取最近使用记录
    getRecentList (pageIndex=1, pageSize=10) {
        const offset = (pageIndex - 1) * pageSize;
        return this.get({
            url: `/rest/storage/recent`,
            config: {
                params: {
                    access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                    enterpriseId: store.userStore.roleInfo?.enterpriseId,
                    offset: offset,
                    limit: pageSize
                }
            },
        }).then(res => {
            const data = res.data.recent;
            (data || []).forEach(item => {
                item.name = item.docName;
            });
            return data;
        });
    }
    // 添加最近使用记录
    addRecent (docId, docName, isMe, docSize, reviewSessionID) {
        return this.post({
            url: `/rest/storage/recent`,
            data: qs.stringify({
                access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                enterpriseId: store.userStore.roleInfo?.enterpriseId,
                docId: docId,
                docName: docName,
                isMe: isMe,
                reviewSessionID: reviewSessionID,
                docSize: docSize,
                lastModifiedTime: Date.now()
            }),
        });
    }
    // 移除最近使用记录
    removeRecent (docId) {
        return this.delete({
            url: `/rest/storage/recent`,
            config: {
                params: {
                    access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                    enterpriseId: store.userStore.roleInfo?.enterpriseId,
                    docId: docId,
                }
            },
        });
    }
    // 清空最近使用记录
    clearRecent () {
        return this.post({
            url: `/rest/storage/cleanRecent`,
            data: qs.stringify({
                access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                enterpriseId: store.userStore.roleInfo?.enterpriseId,
            }),
        });
    }
    // 获取使用空间
    getUseSpace () {
        return this.get({
            url: `/rest/storage/userUsedSpace`,
            config: {
                params: {
                    access_token: store.userStore.token, // '6346771636132d29ea8ba4b7',
                    enterpriseId: store.userStore.roleInfo?.enterpriseId,
                }
            },
        }).then(res => {
            return (res.data && res.data.userUsedSpace) || { docSizeCount: 0 };
        });
    }
    // 创建协作文档
    createShare (docId, deadLine, prohibitComment, userEmail, message, password) {
        return this.doConvert([{ 
            docid: docId, 
            password,
            userEmail,
            message,
        }], 43, {
            reviewClientID: store.collaborationStore.uuidForCollaboration, // 随机的clienId
            deadLine,  // 创建shareReview时的传参
            prohibitComment,  // 创建shareReview时的传参
            annotTitle: store.userStore.userName
        }).then(res => {
            const shareReview = JSON.parse(res.data.shareReview);
            shareReview.fileLink = res.data.fileLink;
            return shareReview;
        });
    }
    // 取消协作文档
    unShare (reviewSessionID, password) {
        return baseUrlApis.getBaseUrlBy(URL_CWS_API).then(baseCWSApi => {
            return this.delete({
                url: baseCWSApi + `/cpdfapi/v1/share-review?access-token=${store.userStore.token}`,
                config: {
                    data: {
                        reviewSessionID, 
                        isSaveDoc: 1,
                        isStorage: 0,
                        password
                    }
                },
            });
        });
    }
    /**
     * 多文档下载zip
     * @param {*} docIds - cmis docId
     * @param {*} shareFiles [{ fileLink, reviewSessionID }]
     * @returns 
     */
    downloadFiles (docIds = [], shareFiles = []) {
        const token = store.userStore.token;
        return baseUrlApis.getBaseUrlBy(URL_CWS_API).then(baseCWSApi => {
            const data = [];
            docIds.forEach(docId => {
                data.push({ docid: docId });
            });
            shareFiles.forEach(item => {
                const { fileLink, reviewSessionID } = item;
                data.push({ 
                    url: fileLink,
                    confText: JSON.stringify({
                        listnewUrl: `${baseCWSApi}/cpdfapi/v1/share-review/listnew?reviewSessionID=${reviewSessionID}&lastTime=0000-00-00%2000%3A00%3A00%3A000&pageObjNum=-1&access-token=${token}`,
                    })
                });
            });
            return this.doConvert(data, 203).then(res => {
                return res.url;
            }, error => {
                this.errorHandler(error);
            });
        });
    }
    downloadFolder (folderId) {
        return this.doConvert(null, 204, {
            cmis_folder_id: folderId
        }).then(res => {
            return res.url;
        }, error => {
            this.errorHandler(error);
        });
    }
    // convertApis.doConvert 接口
    doConvert (data, type, confText, config) {
        return convertApis.doConvert(data, type, Object.assign({
            confText: JSON.stringify(confText),
        }, config || {})).then(res => {
            return new Promise((resolve, reject) => {
                const taskId = res && res.data && res.data.taskid;
                if (taskId === undefined) {
                    reject(res);
                } else {
                    let timer;
                    store.taskStore.hasTask = true;
                    store.taskStore.convertTaskId = taskId;
                    convertApis.doMonitorStatus(taskId, res => {
                        if (res.url) {
                            clearTimeout(timer);
                            resolve(res);
                        } else if (res.data.errorBody) {
                            clearTimeout(timer);
                            const errorBody = JSON.parse(res.data.errorBody);
                            reject(errorBody.message);
                        } else if (res.msg) {
                            clearTimeout(timer);
                            reject(res);
                        }
                    });
                    timer = setTimeout(() => {
                        store.taskStore.hasTask = false;
                        reject('Interface request timeout error!');
                    }, 30000);
                }
            });
        })
    }
    // 查询用户是否被某个企业授予Editor Cloud权限
    hasAssignCloudLicenseState () {
        return baseUrlApis.getBaseUrlBy(URL_CWS_API).then(baseCWSApi => {
            return this.get({
                url: baseCWSApi + `/cpdfapi/v1/client/assign-cloud-license-state?access-token=${store.userStore.token}`,
            }).then(res => {
                return res.data && res.data.hasAssign;
            });
        });
    }
    queryObjectByName ({ name, folderId }) {
        return this.get({
            url: `/rest/storage/checkNameInFolder`,
            config: {
                params: {
                    access_token: store.userStore.token, 
                    enterpriseId: store.userStore.roleInfo?.enterpriseId,
                    folderId,
                    fileName: name,
                }
            },
        }).then(res => {
            return this.utl_parseCmisResult(res.data && res.data.succinctProperties);
        });
    }
    // ============================以下CMIS接口==================================
    // queryObjectByName ({ name, folderId }) {
    //     return this.getCMIS().then(cmss => {
    //         return cmss.getChildren(folderId, {
    //             maxItems: 10000,
    //             skipCount: 0
    //         }).then(res => {
    //             const array = res.objects || [];
    //             for (let index = 0; index < array.length; index++) {
    //                 const item = array[index];
    //                 const object = item.object.succinctProperties;
    //                 if (object['cmis:name'] === name) {
    //                     return this.utl_parseCmisResult(object);
    //                 }
    //             }
    //             return null;
    //         });
    //     });
    //     // return this.getCMIS().then(cmss => {
    //     //     let statement = 'SELECT * FROM cmis:document ';
    //     //     // `SELECT * FROM cmis:document WHERE IN_TREE('${treeId}') AND cmis:name LIKE '${name}'`;
    //     //     if (treeId !== undefined) {
    //     //         statement += (statement.indexOf('WHERE') === -1) ? 'WHERE ' : 'AND ';
    //     //         statement += `IN_TREE('${treeId}') `;
    //     //     }
    //     //     if (folderId !== undefined) {
    //     //         statement += (statement.indexOf('WHERE') === -1) ? 'WHERE ' : 'AND ';
    //     //         statement += `IN_FOLDER('${folderId}') `;
    //     //     }
    //     //     if (name !== undefined) {
    //     //         statement += (statement.indexOf('WHERE') === -1) ? 'WHERE ' : 'AND ';
    //     //         statement += `cmis:name LIKE '${name}' `;
    //     //     }
    //     //     return cmss.query(statement, false).then(res => {
    //     //         res = res.results;
    //     //         if (res && res[0]) return this.utl_parseCmisResult(res[0].succinctProperties);
    //     //         return null;
    //     //     });
    //     // });
    // }
    getObjectById (objectId) {
        return this.getCMIS().then(cmss => {
            return cmss.getObject(objectId, 'latest').then(res => {
                if (!res || !res.succinctProperties) return {};
                const succinctProperties = res.succinctProperties;
                return this.utl_parseCmisResult(succinctProperties);
            });
        });
    }
    getObjectByPath (path) {
        return this.getCMIS().then(cmss => {
            return cmss.getObjectByPath(path).then(res => {
                if (!res || !res.succinctProperties) return {};
                const succinctProperties = res.succinctProperties;
                return this.utl_parseCmisResult(succinctProperties);
            });
        });
    }
    // 获取子节点，包含文档和目录, pageIndex 从1开始, orderBy = ['lastModificationDate', 0 // 升序]
    getChildren (objectId, pageIndex, pageSize, orderBy) {
        const option = { 
            // orderBy: 'folder',
            // orderBy: 'cmis:lastModificationDate',
        };
        if (orderBy) {
            option.orderBy = `cmis:${orderBy[0]}-${orderBy[1]}`;
        }
        if (pageIndex !== undefined && pageSize !== undefined) {
            const offset = (pageIndex - 1) * pageSize;
            option.skipCount = offset;
            option.maxItems = pageSize;
        }
        return this.getCMIS().then(cmss => {
            return cmss.getChildren(objectId, option).then(res => {
                const result = (res.objects || []).reduce((arr, item) => {
                    arr.push(this.utl_parseCmisResult(item.object.succinctProperties));
                    return arr;
                }, []);
                
                return {
                    pageIndex, 
                    pageSize,
                    total: res.numItems,
                    data: result
                };
            });
        });
    }
    createFolder (parentId, name) {
        return this.getCMIS().then(cmss => {
            return cmss.createFolder(parentId, name).then(res => {
                return this.utl_parseCmisResult(res.succinctProperties);
            });
        });
    }
    deleteObject (objectId) {
        return this.getCMIS().then(cmss => {
            return cmss.deleteObject(objectId, true);
        });
    }
    deleteTree (objectId) {
        return this.getCMIS().then(cmss => {
            return cmss.deleteTree(objectId, true, 'delete');
        });
    }
    rename (objectId, newName) {
        return this.getCMIS().then(cmss => {
            return cmss.updateProperties(objectId, {
                'cmis:name': newName
            }).then(res => {
                const succinctProperties = res.succinctProperties;
                return this.utl_parseCmisResult(succinctProperties);
            }, (err) => {
                store.appStore.setGlobalMessage({ type: 'error', content: 'Same name siblings are not allowed!', duration: 2 });
                throw err;
            });
        });
    }
    /**
     * 移动文件
     * @param {*} objectId 文件id
     * @param {*} folderId 文件目录id，可不传
     * @param {*} targetFolderId 新目录id
     * @returns 
     */
    moveObject (objectId, folderId, targetFolderId) {
        return this.getCMIS().then(cmss => {
            return cmss.moveObject(objectId, folderId, targetFolderId).then(res => {
                const succinctProperties = res.succinctProperties;
                return this.utl_parseCmisResult(succinctProperties);
            }, (err) => {
                return this.utl_parseErrorCode(err, 'moveObject');
            });
        });
    }
    getFolderTree (folderId, filterObjectIdList = []) {
        return this.getCMIS().then(cmss => {
            return cmss.getFolderTree(folderId).then(res => {
                const array = [];
                const loop = (item) => {
                    const children = item.children || [];
                    item = this.utl_parseCmisResult(item.object.object.succinctProperties);
                    if (filterObjectIdList.indexOf(item.objectId) > -1) return ;
                    item.children = [];
                    for (let index = 0; index < children.length; index++) {
                        item.children.push(loop(children[index]));
                    }
                    return item;
                }
                for (let index = 0; index < res.length; index++) {
                    const item = res[index];
                    const ret = loop(item);
                    ret && array.push(ret);
                }
                return array;
            });
        });
    }
    // 创建文档，从无开始创建
    createDocument (parentId, buffer, input, fileType) {
        return this.getCMIS().then(cmss => {
            if (!(buffer instanceof Array)) {
                buffer = [buffer];
            }
            const blob = new Blob(buffer, fileType && { type: fileType });
            return cmss.createDocument(parentId, blob, input).then(res => {
                const succinctProperties = res.succinctProperties;
                return this.utl_parseCmisResult(succinctProperties);
            }, err => {
                return this.utl_parseErrorCode(err, 'createDocument');
            });
        });
    }
    // 创建文档，从无开始创建 - 分片方式
    createDocumentByChunk (parentId, buffer, input) {
        return this.getCMIS().then(cmss => {
            if (!(buffer instanceof Array)) {
                buffer = [buffer];
            }
            
            const blob = new Blob(buffer);
            const bytesPerPiece = 10 * 1024 * 1024; // 每个文件切片大小定为10MB
            let start = 0;
            let end = bytesPerPiece;
            let chunk = blob.slice(start, end);
            return cmss.createDocument(parentId, chunk, input).then(res => {
                const appendContentStream = (res) => {
                    const succinctProperties = res.succinctProperties;
                    const objectInfo = this.utl_parseCmisResult(succinctProperties);
                    start = end;
                    end = start + bytesPerPiece;
                    chunk = blob.slice(start, end);
                    const chunkSize = chunk.size;
                    if (chunkSize === 0) return objectInfo;
                    return cmss.appendContentStream(objectInfo.objectId, chunk, chunkSize < bytesPerPiece).then(appendContentStream);
                }
                return appendContentStream(res);
            });
        });
    }
    // 更新文档内容
    setContentStream (objectId, buffer, fileType) {
        return this.getCMIS().then(cmss => {
            if (!(buffer instanceof Array)) {
                buffer = [buffer];
            }
            const blob = new Blob(buffer, fileType && { type: fileType });
            return cmss.setContentStream(objectId, blob, true).then(res => {
                if (!res || !res.succinctProperties) return {};
                const succinctProperties = res.succinctProperties;
                return this.utl_parseCmisResult(succinctProperties);
            });
        });
    }
    // 更新文档内容 - 增量方式
    appendContentStream (objectId, buffer) {
        return this.getCMIS().then(cmss => {
            if (!(buffer instanceof Array)) {
                buffer = [buffer];
            }
            const blob = new Blob(buffer);
            
            // const link = window.URL.createObjectURL(blob);
            // const a = document.createElement('a');
            // a.download = 'chunk.pdf';
            // a.href = link;
            // a.click();

            return cmss.appendContentStream(objectId, blob, false).then(res => {
                if (!res || !res.succinctProperties) return {};
                const succinctProperties = res.succinctProperties;
                return this.utl_parseCmisResult(succinctProperties);
            });
        });
    }
    // 获取文件流，可以指定获取某段内容
    getDocumentStream (objectId, offset, size) {
        return this.getCMIS().then(cmss => {
            // objectId不带版本号，需要重新获取最新的objectId，才能取到最新版本的文档内容
            let promise = Promise.resolve(objectId);
            if (objectId.indexOf(',') === -1) {
                promise = this.getObjectById(objectId).then(res => {
                    return res.objectId;
                });
            }
            return promise.then((objectId) => {
                return this.get({
                    url: cmss.defaultRepository.rootFolderUrl,
                    config: {
                        headers: {
                            Authorization: 'Bearer ' + store.userStore.token,
                            Range: offset!==undefined && size!==undefined && `bytes=${offset}-${offset+size}`,
                        },
                        params: {
                            cmisselector: 'content',
                            objectId,
                            download: 'attachment',
                            succinct: true,
                        },
                        responseType: 'blob',
                    },
                });
            }).then(blob => {
                return blob;
            }, err => {
                return this.utl_parseErrorCode(err, 'getContentStreamURL');
            });
        });
    }
    getDocumentStreamUrl (objectId) {
        return `${this.cmss.defaultRepository.rootFolderUrl}?cmisselector=content&objectId=${objectId}&download=attachment&succinct=true`;
    }
    // 获取文档缩略图
    getDocumentThumbnail (objectId) {
        return this.getCMIS().then(cmss => {
            return cmss.getRenditions(objectId).then(res => {
                let streamId;
                for (let index = 0; index < res.length; index++) {
                    const element = res[index];
                    if (element.kind === 'smx:thumbnail_general') {
                        streamId = element.streamId;
                        break;
                    }
                }
                return streamId;
            }).then(streamId => {
                if (!streamId) return streamId;
                return this.get({
                    url: cmss.getContentStreamURL(objectId, 'attachment', streamId),
                    config: {
                        headers: {
                            Authorization: 'Bearer ' + store.userStore.token,
                        }
                    },
                });
            });
        });
    }

    utl_parseCmisResult (succinctProperties) {
        if (!succinctProperties) return succinctProperties;
        const result = {};
        for (const key in succinctProperties) {
            let value = succinctProperties[key];
            if (typeof value === 'string') {
                value = value.replace(/^cmis:/, '');
            }
            result[key.replace(/^cmis:/, '').replace(/^smxc:/, '')] = value;
            result['docId'] = result['objectId'];
            result['userId'] = result['createdBy'];
            result['docName'] = result['name'];
            result['lastModifiedTime'] = result['lastModificationDate'];
            result['docSize'] = result['contentStreamLength'];
        }
        return result;
    }
    utl_parseErrorCode (err, funName) {
        const rbody = err.response.body;
        const reader = rbody.getReader();
        const uintArrayToString = uintArray => {
            let str = '';
            for (let i = 0;i < uintArray.length;i++) {
                str += String.fromCharCode(uintArray[i]);
            }
            return str;
        }
        return reader.read().then(ret => {
            const str = uintArrayToString(ret.value);
            const result = JSON.parse(str);
            const errorCode = result.errorCode;
            if (['621', '721'].includes(errorCode) && funName === 'moveObject') {
                this.errorHandler(intl.formatMessage({ id: 'FoxitStorage.Error.CannotMoveWithDuplicateName' }));
            } else if (errorCode === '651') {
                this.errorHandler('Cannot create document with duplicate name');
            }
            return Promise.reject(result);
        });
    }
}
    